export class PhysicalPropertiesModel {
  public shippable: boolean;

  constructor(params: PhysicalPropertiesModel) {
    this.shippable = params.shippable;
  }

  public static fromCartV1({shippable}: {shippable?: boolean}) {
    return new PhysicalPropertiesModel({
      shippable,
    });
  }
}
